import { effectiveRequestedQuantity } from './artworkSource'

function uploadedImageKey(image, index) {
  if (image?.id === undefined || image?.id === null) return `record:${index}`

  return `id:${image.id}`
}

function requestedQuantity(image, imageConfigs) {
  const config = image?.id === undefined || image?.id === null
    ? undefined
    : imageConfigs?.[image.id]

  return effectiveRequestedQuantity(config, image)
}

function isUploadedImageId(value) {
  if (typeof value === 'number') return Number.isInteger(value) && value > 0
  if (typeof value !== 'string' || !/^\d+$/.test(value.trim())) return false

  return Number(value) > 0
}

export function hasPlacedArtwork(layoutJson) {
  if (!Array.isArray(layoutJson?.sheets)) return false

  return layoutJson.sheets.some(sheet => (
    Array.isArray(sheet?.items) && sheet.items.some(item => (
      isUploadedImageId(item?.uploaded_image_id)
    ))
  ))
}

export function imagesArePending(images) {
  return Array.isArray(images) && images.some(image => (
    (image?.processingStatus ?? image?.processing_status ?? image?.status) === 'pending'
  ))
}

function uniqueUploadedImages(images) {
  const uniqueImages = new Map()
  const imageRecords = Array.isArray(images) ? images : []

  for (const [index, image] of imageRecords.entries()) {
    const key = uploadedImageKey(image, index)
    if (!uniqueImages.has(key)) uniqueImages.set(key, image)
  }

  return [...uniqueImages.values()]
}

export function countUniqueDesigns(images, imageConfigs = {}) {
  return uniqueUploadedImages(images).filter(
    image => requestedQuantity(image, imageConfigs) > 0
  ).length
}

export function requestedTotalQuantity(images, imageConfigs = {}) {
  return uniqueUploadedImages(images).reduce(
    (total, image) => total + requestedQuantity(image, imageConfigs),
    0
  )
}

export function summarizeRequestedArtwork(images, imageConfigs = {}) {
  const uniqueImages = uniqueUploadedImages(images)

  return {
    uniqueDesignCount: uniqueImages.filter(
      image => requestedQuantity(image, imageConfigs) > 0
    ).length,
    requestedTotalQuantity: uniqueImages.reduce(
      (total, image) => total + requestedQuantity(image, imageConfigs),
      0
    ),
  }
}
